<td>
  <span *ngIf="!input_copyToClipboard">
    <!-- text -->
    <ng-container *ngIf="input_type == 'text'">
      {{ input_value }}
    </ng-container>

    <!-- checked -->
    <ng-container *ngIf="input_type == 'checked'">
      <i class="fas fa-check text-success" *ngIf="input_value"></i>
      <i class="fas fa-times text-danger" *ngIf="!input_value"></i>
    </ng-container>

    <!-- date -->
    <ng-container *ngIf="input_type == 'date'">
      <span> {{ input_value | dateConverter : input_lang }} </span>
    </ng-container>

    <!-- number -->
    <ng-container *ngIf="input_type == 'number'">
      {{ input_value | numberSeparator }}
    </ng-container>

    <!-- list -->
    <ng-container *ngIf="input_type == 'list'">
      <ng-content select="app-expand-item"></ng-content>
    </ng-container>
  </span>

  <!-- copy to clipboard -->

  <span *ngIf="input_copyToClipboard" copyToClipboard>
    <!-- text -->
    <ng-container *ngIf="input_type == 'text'">{{ input_value }}</ng-container>

    <!-- checked -->
    <ng-container *ngIf="input_type == 'checked'">
      <i class="fas fa-check text-success" *ngIf="input_value"></i>
      <i class="fas fa-times text-danger" *ngIf="!input_value"></i>
    </ng-container>

    <!-- date -->
    <ng-container *ngIf="input_type == 'date'">
      <span> {{ input_value | dateConverter : input_lang }} </span>
    </ng-container>

    <!-- number -->
    <ng-container *ngIf="input_type == 'number'">
      {{ input_value | numberSeparator }}
    </ng-container>

    <!-- list -->
    <ng-container *ngIf="input_type == 'list'">
      <ng-content select="app-expand-item"></ng-content>
    </ng-container>
  </span>
</td>
